
































import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../../shared/services/mixin";
import {Component, Watch} from "vue-property-decorator";
import PostOfficeSelector from "@/shared/components/PostOfficeSelector/index.vue";
import {ExpensePostOfficeParams} from "@/modules/receiptsexpenses/expensepostoffice/params";
import {ExpensePostOfficeStore} from "@/modules/receiptsexpenses/expensepostoffice/store";
import LadingStatusLabel from "@/shared/components/LadingStatusLabel/index.vue";
import {LadingPaymentType} from "@/enums/type";
import LadingPaymentTypeLabel from "@/modules/ladings/List/components/PaymentTypeLabel.vue";
import ExpensePostOfficeTable from "@/modules/receiptsexpenses/expensepostoffice/List/ExpensePostOfficeTable/index.vue";
import {PAGE_SIZE_OPTIONS} from "@/shared/constant";
import {allCreditPostOffice} from "@/modules/receiptsexpenses/expensepostoffice/services";
import TableToExcel from "@linways/table-to-excel";
import ExpensePostOfficeExcel from "@/modules/receiptsexpenses/expensepostoffice/List/ExpensePostOfficeExcel/index.vue";

@Component({
    name: "DebtPostOffice",
    components: {
        ExpensePostOfficeExcel,
        ExpensePostOfficeTable, LadingPaymentTypeLabel, LadingStatusLabel, PostOfficeSelector
    }
})
export default class extends mixins(CommonMixin) {
    params: ExpensePostOfficeParams = new ExpensePostOfficeParams();
    LadingPaymentType = LadingPaymentType;
    debtPostOfficesExcel = [] as any;
    isExporting = false;

    created() {
        ExpensePostOfficeStore.updateParamsCreditPostOffice(this.params);
        ExpensePostOfficeStore.listCreditPostOffice(ExpensePostOfficeStore.params);
    }

    @Watch("params", {deep: true})
    onChangeParams(val: any) {
        ExpensePostOfficeStore.updateParamsCreditPostOffice({...val, page: 1});
        ExpensePostOfficeStore.listCreditPostOffice(ExpensePostOfficeStore.params);
    }

    get debtPostOffices() {
        return ExpensePostOfficeStore.ids.map((id: number) => ExpensePostOfficeStore.data[id]);
    }

    get pagination() {
        return {
            current: ExpensePostOfficeStore.meta.page,
            pageSize: ExpensePostOfficeStore.meta.limit,
            total: ExpensePostOfficeStore.meta.total,
            showTotal: (total: number) => `Tổng cộng ${total} bản ghi`,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: PAGE_SIZE_OPTIONS
        }
    }

    onChangePage(pagination: any) {
        ExpensePostOfficeStore.updateParamsCreditPostOffice({
            ...ExpensePostOfficeStore.params,
            page: pagination.current,
            limit: pagination.pageSize
        })
        ExpensePostOfficeStore.listCreditPostOffice(ExpensePostOfficeStore.params);
    }

    async exportExcel() {
        try {
            await this.getDataExport();
            setTimeout(() => {
                TableToExcel.convert(document.getElementById("table-excel-expense-postoffice"), {
                    name: `Danh sách trả bưu cục.xlsx`,
                    sheet: {
                        name: "Sheet 1"
                    }
                });
            }, 200)
        } catch (e) {
        }
    }

    async getDataExport() {
        try {
            this.isExporting = true;
            const { data } = await allCreditPostOffice(ExpensePostOfficeStore.params);
            this.debtPostOfficesExcel = data.datas;
        } catch (e) {
            this.$message.error(e?.response?.data?.message || "Xuất excel lỗi");
        } finally {
            this.isExporting = false;
        }
    }
}
